import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEllipsisVerticalIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 3.6 16.2",
	style: { enableBackground: "new 0 0 3.6 16.2" },
	xmlSpace: "preserve",
	...props,
	children: [
		/* @__PURE__ */ _jsx("style", {
			type: "text/css",
			children: "\n	.ellipsis-vertical-icon-st0{fill:currentColor;}\n"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "ellipsis-vertical-icon-st0",
			d: "M1.8,9.9c1,0,1.8-0.8,1.8-1.8S2.8,6.3,1.8,6.3S0,7.1,0,8.1S0.8,9.9,1.8,9.9z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "ellipsis-vertical-icon-st0",
			d: "M1.8,3.6c1,0,1.8-0.8,1.8-1.8S2.8,0,1.8,0S0,0.8,0,1.8S0.8,3.6,1.8,3.6z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "ellipsis-vertical-icon-st0",
			d: "M1.8,16.2c1,0,1.8-0.8,1.8-1.8s-0.8-1.8-1.8-1.8S0,13.4,0,14.4S0.8,16.2,1.8,16.2z"
		})
	]
});
export default SvgEllipsisVerticalIcon;
